import { render, staticRenderFns } from "./MainMenuNavbar.vue?vue&type=template&id=373ac948"
import script from "./MainMenuNavbar.vue?vue&type=script&lang=js"
export * from "./MainMenuNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports